export default __webpack_public_path__ + "static/media/ENheader.f921dab8.png";